<p-editor [placeholder]="'Escriba aquí el motivo de la cancelación mínimo 10 caracteres...'" 
    [(ngModel)]="observaciones" (ngModelChange)="observacionesChange.emit(observaciones)" 
    (onInit)="onEditorInit($event)" [style]="{ height: '200px' }" >
    <ng-template pTemplate="header">
            <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-underline" aria-label="Underline"></button>
                <button type="button" class="ql-strike" aria-label="Strikethrough"></button>
                <button class="ql-image" type="button"></button>
                <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
                <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
                <button type="button" class="ql-align" value="" aria-label="Align Left"></button>
                <button type="button" class="ql-align" value="center" aria-label="Align Center"></button>
                <button type="button" class="ql-align" value="right" aria-label="Align Right"></button>
                <button type="button" class="ql-align" value="justify" aria-label="Justify"></button>
            </span>
    </ng-template>
</p-editor>
<input #fileInput type="file" accept="image/*" style="display: none" (change)="onImagenSeleccionada($event)"/>
